/** Default page size for project/collection list grids (admin pages). */
export const DEFAULT_LIST_PAGE_SIZE = 5;

/** Default page size for map-editor entity list fetches. */
export const DEFAULT_ENTITY_PAGE_SIZE = 50;

/** Backend max page size for filtered project/collection lists. */
export const MAX_LIST_PAGE_SIZE = 200;
